import { useHistory } from 'react-router-dom';
import * as CampaignModal from 'components/campaign-modal';
import * as CreateCampaignDialog from 'components/create-campaign-dialog';
import { NucleoIcon } from 'components/nucleo-icon';
import { SearchListItem } from 'components/search/SearchListItem';
import { useSearchStore } from 'components/search/useSearchStore';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFlags } from 'launchdarkly-react-client-sdk';

const SearchActions = () => {
    const { newCampaignCreationOverlay = false } = useFlags();
    const { accountId } = useCurrentAccount();
    const history = useHistory();
    const { query } = useSearchStore();
    const hasQuery = query.length > 0;

    if (hasQuery) {
        return null;
    }

    return (
        <div className={'flex flex-col'}>
            {newCampaignCreationOverlay ? (
                <CreateCampaignDialog.Root
                    triggerLocation={CreateCampaignDialog.TriggerLocation.SearchBar}
                >
                    <CreateCampaignDialog.Trigger asChild={true}>
                        <div>
                            <SearchListItem>
                                <div className={'flex gap-2'}>
                                    <div
                                        className={
                                            'flex aspect-square h-10 items-center justify-center rounded-md border border-gray-200 text-blue-500'
                                        }
                                    >
                                        <NucleoIcon icon="bullhorn" />
                                    </div>
                                    <div className={'flex flex-grow flex-col'}>
                                        <p className={'text-sm font-medium text-gray-800'}>
                                            Create a campaign
                                        </p>
                                        <p className={'text-sm text-gray-800'}>
                                            Start a new fundraising campaign
                                        </p>
                                    </div>
                                </div>
                            </SearchListItem>
                        </div>
                    </CreateCampaignDialog.Trigger>
                </CreateCampaignDialog.Root>
            ) : (
                <CampaignModal.Root>
                    <CampaignModal.Trigger asChild={true}>
                        <div>
                            <SearchListItem>
                                <div className={'flex gap-2'}>
                                    <div
                                        className={
                                            'flex aspect-square h-10 items-center justify-center rounded-md border border-gray-200 text-blue-500'
                                        }
                                    >
                                        <NucleoIcon icon="bullhorn" />
                                    </div>
                                    <div className={'flex flex-grow flex-col'}>
                                        <p className={'text-sm font-medium text-gray-800'}>
                                            Create a campaign
                                        </p>
                                        <p className={'text-sm text-gray-800'}>
                                            Start a new fundraising campaign
                                        </p>
                                    </div>
                                </div>
                            </SearchListItem>
                        </div>
                    </CampaignModal.Trigger>
                </CampaignModal.Root>
            )}
            <SearchListItem onClick={() => history.push(`/accounts/${accountId}/contacts/new`)}>
                <div className={'flex gap-2'}>
                    <div
                        className={
                            'flex aspect-square h-10 items-center justify-center rounded-md border border-gray-200 text-blue-500'
                        }
                    >
                        <NucleoIcon icon="userPlus" />
                    </div>
                    <div className={'flex flex-grow flex-col'}>
                        <p className={'text-sm font-medium text-gray-800'}>Add a contact</p>
                        <p className={'text-sm text-gray-800'}>Create a new contact</p>
                    </div>
                </div>
            </SearchListItem>
            <SearchListItem onClick={() => history.push(`/accounts/${accountId}/transactions/new`)}>
                <div className={'flex gap-2'}>
                    <div
                        className={
                            'flex aspect-square h-10 items-center justify-center rounded-md border border-gray-200 text-blue-500'
                        }
                    >
                        <NucleoIcon icon="receipt" />
                    </div>
                    <div className={'flex flex-grow flex-col'}>
                        <p className={'text-sm font-medium text-gray-800'}>New transaction</p>
                        <p className={'text-sm text-gray-800'}>Manually add a new transaction</p>
                    </div>
                </div>
            </SearchListItem>
        </div>
    );
};

export { SearchActions };
